<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <div class="md-layout">
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-icon vendor-icon">
              <md-icon style="font-size: 30px !important">summarize</md-icon>
            </div>
          </md-card-header>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>Customer</label>
              <md-input
                v-model="customer"
                @click="openCustomerModal(true)"
                readonly
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-15 DateFormate">
            <!-- <md-datepicker md-immediately v-model="fromDate"
              ><label>GL From Date</label></md-datepicker
            > -->
            <date-picker
                valueType="format"
                format="DD-MMM-YYYY"
                placeholder="From Date"
                v-model="fromDate"
            ></date-picker>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-15 DateFormate">
            <!-- <md-datepicker md-immediately v-model="toDate"
              ><label>GL To Date</label></md-datepicker
            > -->
            <date-picker
                valueType="format"
                format="DD-MMM-YYYY"
                placeholder="To Date"
                v-model="toDate"
                :disabled-date="disabledDates"
                :disabled="!fromDate"
            ></date-picker>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-30">
            <div style="margin-top: 10px">
              <md-button
                class="md-raised md-info search-btn"
                @click="generateCustomerData()"
                style="margin-right: 5px"
                >Generate</md-button
              >
              <!-- v-if="requestStatus === 'COMPLETED'" -->
              <md-button
                class="md-raised md-primary search-btn"
                @click="getSubmitRequest()"
                style="margin-right: 5px"
              >
                Refresh
              </md-button>
              <!-- v-if="requestStatus !== 'COMPLETED'" if refresh button hide than use this-->
              <a
                :href="downloadReport + '/' + customerLegderId"
                target="_blank"
                v-if="requestStatus === 'COMPLETED'"
              >
                <md-button
                  class="md-raised md-primary search-btn"
                  style="margin-right: 5px"
                >
                  Download
                </md-button>
              </a>
              <md-button
                class="md-raised md-rose search-btn"
                style="margin-right: -4rem"
                @click="clear()"
              >
                Clear
              </md-button>
            </div>
          </div>
          <div
            class="md-layout-item md-small-size-100 md-size-10"
            style="margin-left: 3rem;"
          >
            <md-field
              ><label>Status</label>
              <md-input v-model="requestStatus" readonly></md-input
            ></md-field>
          </div>
        </div>
      </md-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header
          class="md-card-header-text md-layout-item md-card-header-rose"
          style="margin-top: 5px"
        >
          <div class="card-text">
            <h6 class="title">Customer Ledger</h6>
          </div>
        </md-card-header>
        <div style="position: absolute; margin-top: 5px; margin-left: 9rem;">
          <marquee style="background-color: black; width: 30rem">
            <p class="marque-text">
              Note :- "Any transaction done recently will take 48 hours to
              reflect in Ledger"<b></b>
            </p>
          </marquee>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>Tenant Name</label>
              <md-input type="text" v-model="tenantName" disabled></md-input>
            </md-field>
          </div>
          <!-- <div class="md-layout-item md-small-size-100 md-size-20">
          <md-field>
            <label>Statement For Period of</label>
            <md-input type="text" v-model="statementForPeriodOf" disabled></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-20">
          <md-field>
            <label>Escalation Due Date</label>
            <md-input type="text" v-model="escalationDueDate" disabled></md-input>
          </md-field>
        </div> -->
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>PAN No.</label>
              <md-input type="text" v-model="panNo" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>Opening Balance</label>
              <md-input
                type="text"
                v-model="openingBalance"
                disabled
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>Security Deposit</label>
              <md-input
                type="text"
                v-model="securityDepositRaised"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>Security Deposit Refund</label>
              <md-input
                type="text"
                v-model="securityDepositPaid"
                disabled
              ></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout-item" style="margin-top: 15px">
          <b-table
            striped
            hover
            outlined
            sticky-header
            :items="gridData"
            :fields="gridField"
            show-empty
            class="bg-white"
            md-height
          >
            <template #cell(unit_billable_area)="data">
              {{ data.item.unit_billable_area }}
              {{ data.item.unit_billable_area_uom }}
            </template>
          </b-table>
        <div style="float: right;color: red; font-size: medium; font-style: oblique; font-weight: 600;">
          *Note :- After click on generate kindly wait for 2-3min and click on refresh for download.
        </div>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </md-card>
    </div>
    <b-modal
      v-model="showModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Customer"
      @hidden="openCustomerModal(false, null)"
    >
      <b-table
        striped
        hover
        outlined
        :items="gridDataCustomer"
        :fields="gridFieldCustomer"
        show-empty
        class="bg-white"
        sticky-header
        @row-clicked="selectedCustomer"
      >
      </b-table>
      <customer />
    </b-modal>
  </div>
</template>

<script>
import commonHelper from "../../../utility/common.helper.utility";
import URL_UTILITY from "../../../utility/url.utility";
import customer from "../Customer/Customer.vue";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    customer,
    DatePicker
  },
  name: "",
  watch: {
    currentPage: function() {
      this.getCustomerLedgerDetails();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getCustomerLedgerDetails();
    },
  },
  data() {
    return {
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      currentPage: 1,
      totalRows: null,
      gridData: [],
      customer: null,
      downloadReport: URL_UTILITY.getDownloadReportUrl,
      customerLegderId: null,
      requestStatus: null,
      gridDataCustomer: [],
      gridFieldCustomer: [
        {
          key: "customer",
        },
        {
          key: "customer_id",
        },
      ],
      tenantName: null,
      securityDepositPaid: null,
      gstn: null,
      securityDepositRaised: null,
      statementForPeriodOf: null,
      escalationDueDate: null,
      tanNo: null,
      panNo: null,
      openingBalance: null,
      customerId: null,
      showModal: false,
      requestId: null,
      templateId: null,
      submitRequestId: null,
      leId: null,
      finYear: null,
      fromDate: null,
      toDate: null,
      unsubscribe: null,
      gridField: [
        {
          key: "lease_prj_name",
          label: "Project Name",
          class: "prj-col",
        },
        {
          key: "gl_date_format",
          label: " GL Date",
        },
        {
          key: "unit_billable_area",
          label: "Unit Area",
        },
        {
          key: "trx_num",
          label: "Invoice No.",
        },
        {
          key: "trx_date",
          label: "Invoice Date",
        },
        {
          key: "trx_description",
          label: "Description",
        },
        {
          key: "applied_trx",
          label: "Applied Invoice",
        },
        {
          key: "amount_dr",
          label: "Debit",
        },
        {
          key: "amount_cr",
          label: "Credit",
        },
        {
          key: "net_amt",
          label: "Net Amount",
        },
        {
          key: "running_balance",
        },
        {
          key: "trx_type",
          label: "Invoice Type",
        },
        {
          key: "trx_status",
          label: "Status",
        },
        {
          key: "tp_reg_num",
          key: "TP Reg No.",
        },
      ],
    };
  },
  mounted() {
    this.leId = sessionStorage.getItem("leId")
      ? sessionStorage.getItem("leId")
      : "All";
    this.finYear = sessionStorage.getItem("finYear")
      ? sessionStorage.getItem("finYear")
      : "All";
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "shared/setLeId" ||
        mutation.type === "shared/setFinYear"
      ) {
        this.leId = state.shared.leId;
        this.finYear = state.shared.finYear;
      }
    });
    this.getCustomer();
    this.getCustomerRequestId();
    this.getCustomerTemplateId();
  },
  methods: {
    generateCustomerData() {
      if (this.customerId && this.fromDate && this.toDate) {
        const payload = {
          request_num: 0,
          request_id: this.requestId,
          template_id: this.templateId,
          schedule_type: "asap", //pass hardcode
          request_start_date: null,
          request_end_date: null,
          resubmit_interval: null,
          resubmit_interval_unit: null,
          day_of_month: null,
          day_of_week: null,
          output_format_id: "XLS", //pass hardcode
          no_of_args: 25,
          request_parameter:
            this.customerId +
            "," +
            null +
            "," +
            commonHelper.formattedDate(this.fromDate) +
            "," +
            commonHelper.formattedDate(this.toDate),
          sms_flag: false,
          email_flag: false,
          whatsapp_flag: false,
          child_req_count: null,
          email_comm_template_id: null,
          sms_comm_template_id: null,
          whatsapp_comm_template_id: null,
          argument1: this.customerId,
          argument2: null,
          argument3: commonHelper.formattedDate(this.fromDate),
          argument4: commonHelper.formattedDate(this.toDate),
          argument5: this.legalEntity,
          argument6: null,
          argument7: null,
          argument8: null,
          argument9: null,
          argument10: null,
          argument11: null,
          argument12: null,
          argument13: null,
          argument14: null,
          argument15: null,
          argument16: null,
          argument17: null,
          argument18: null,
          argument19: null,
          argument20: null,
          argument21: null,
          argument22: null,
          argument23: null,
          argument24: null,
          argument25: null,
        };
        this.gridData = [];
        this.$store.dispatch("shared/setLoader", true);
        this.$store
          .dispatch("customer/generateCustomerData", payload)
          .then((resp) => {
            this.$store.dispatch("shared/setLoader", false);
            if (resp.status === 201) {
              this.customerLegderId = resp.data.data[0].id;
              this.getCustomerLedgerHdr();
              this.getCustomerLedgerDetails();
              this.getSubmitRequest();
            }
          });
      } else {
        alert("Please Select From Date & To Date");
      }
    },
    getCustomerLedgerHdr() {
      const payload = {
        customer_id: this.customerId,
      };
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("customer/getCustomerLedgerHdr", payload)
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            const result = resp.data.data;
            this.tenantName = result.customer_name;
            this.tanNo = result.tan_no;
            this.panNo = result.pan_no;
            this.securityDepositRaised = result.raised_sd;
            this.securityDepositPaid = result.paid_sd;
          }
        });
    },
    getCustomerLedgerDetails() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        customer_id: this.customerId,
        gl_from_date: commonHelper.formattedDate(this.fromDate),
        gl_to_date: commonHelper.formattedDate(this.toDate),
      };
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("customer/getCustomerLedgerDetails", payload)
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            this.gridData = resp.data.data.page;
            this.totalRows = resp.data.data.total_elements;
          }
        });
    },
    getCustomer() {
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("customer/getCustomer")
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            const result = resp.data.data;
            this.gridDataCustomer = result;
            this.customer = result[0].customer;
            this.customerId = result[0].customer_id;
            this.legalEntity = result[0].le_id;
          }
        })
        .catch(() => {
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    openCustomerModal(flag) {
      this.showModal = flag;
    },
    selectedCustomer(item) {
      this.customerId = item.customer_id;
      this.customer = item.customer;
      this.showModal = false;
    },
    getCustomerRequestId() {
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("customer/getCustomerRequestId")
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            this.requestId = resp.data.data.request_id;
          }
        })
        .catch(() => {
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    getCustomerTemplateId() {
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("customer/getCustomerTemplateId")
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            this.templateId = resp.data.data.template_id;
          }
        })
        .catch(() => {
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    getSubmitRequest() {
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("customer/getSubmitRequest", this.customerLegderId)
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            this.generateRequest = resp.data.data;
            this.requestStatus = resp.data.data[0].status;
          }
        })
        .catch(() => {
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    clear() {
      this.fromDate = null;
      this.toDate = null;
      this.gridData = [];
      this.requestStatus = null;
      this.tenantName = null;
      this.securityDepositRaised = null;
      this.gstn = null;
      this.securityDepositPaid = null;
      this.statementForPeriodOf = null;
      this.escalationDueDate = null;
      this.tanNo = null;
      this.panNo = null;
      this.openingBalance = null;
    },
      disabledDates(date) {
      return commonHelper.disabledDates(date, this.fromDate);
    },
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<style>
.prj-col > div {
  width: 180px !important;
}
</style>
